module.exports = __webpack_public_path__ + "img/dal.fc09912a.png";